import React, {useEffect, useState} from 'react';
import {Link, useNavigate, useParams} from "react-router-dom";
import http from "../framework/http";
import DOMPurify from "dompurify";

function BlogViewer() {
    const params = useParams();
    const navigate = useNavigate();
    const [blog,setBlog] = useState();

    useEffect(() => {
        async function loadModel() {
            const res = await http.get("/blog/" + params.blogId);
            if (res.data?.code === 200) {
                if (!res.data.data) {
                    navigate("/404");
                    return;
                }
                console.log(res.data.data)
                setBlog(res.data.data);
            }
        }

        loadModel();
    }, [params]);

    return (
        <div className="blog-article-container">
            <article className="blog-article">
                <header className="blog-article-header">
                    <h1 className="blog-article-title">{blog?.title}</h1>
                    <div className="blog-article-meta">
                        <time className="blog-article-date">
                            {blog?.createdTime && new Date(blog.createdTime).toLocaleDateString('en-US', { 
                                year: 'numeric', 
                                month: 'long', 
                                day: 'numeric' 
                            })}
                        </time>
                    </div>
                </header>

                <div 
                    className="blog-article-content"
                    dangerouslySetInnerHTML={{
                        __html: DOMPurify.sanitize(blog?.content)
                    }}
                />

                <footer className="blog-article-footer">
                    <Link to="/blogs" className="blog-back-link">
                        Back to News
                    </Link>
                </footer>
            </article>
        </div>
    );
}

export default BlogViewer;
